export default __webpack_public_path__ + "static/media/Logo.3c230dc9.png";